import { Button, Typography } from '@mui/material'
import './styles.css'
import { sxButtonLabel, sxButtonText, sxButtonTextAccessibility } from './sxProps'
import { ConteudoAnexo } from '../../interfaces/entities/SaudeBemEstar/Conteudos/ConteudoAnexo'
import { useAccessibility } from '../../Store/contexts/AccessibilityContext'

interface AttachmentListProps {
  attachments: ConteudoAnexo[]
  onClick: (attachment: ConteudoAnexo) => void
}

const AttachmentList = ({ attachments, onClick }: AttachmentListProps) => {
  const accessibility = useAccessibility();

  return (
    <div className='anexos-list'>
      {attachments?.map((item, index) => (
        <Button
          onClick={() => onClick(item)}
          variant='text'
          sx={accessibility.contrastMode ? sxButtonTextAccessibility : sxButtonText}
          key={index}
        >
          <Typography
            sx={sxButtonLabel}
          >
            {item.descr}
          </Typography>
        </Button>
      ))}
    </div>
  )
}

export default AttachmentList